import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useQuery } from "@tanstack/react-query";
import { api, errDetail } from "@/lib/api";
import { useI18n } from "@/i18n/I18n";

export function useErrorToast() {
  const { t, has } = useI18n();
  const navigate = useNavigate();
  return useCallback((e) => {
    const d = errDetail(e);
    const msg = d && has(`err.${d}`) ? t(`err.${d}`) : d || t("common.error");
    const upsell = /^(limit_|feature_|roles_locked)/.test(d);
    toast.error(msg, upsell ? { action: { label: t("limit.viewPlans"), onClick: () => navigate("/plans") } } : undefined);
  }, [t, has, navigate]);
}

// Shared empty list: a new [] default on each render would defeat useMemo while loading
export const NONE = [];
export const useLocations = () => useQuery({ queryKey: ["locations"], queryFn: () => api.get("/locations").then((r) => r.data) });
export const useCategories = () => useQuery({ queryKey: ["categories"], queryFn: () => api.get("/categories").then((r) => r.data) });

export function useCatLabel() {
  const { t } = useI18n();
  return useCallback((c) => (c ? c.name || t(`cat.${c.key}`) : ""), [t]);
}
